function Fields(){
	if ($('.fields-index-search:not(.v2)').length && $('.fields-index-search:not(.v3)').length)
		this.init();

	//if ($('.switch.btn').length)
	//	this.chairsSwitch();
}

Fields.prototype.chairsSwitch = function() {
	//console.log('chairsSwitch');
	$('body').on('click', 'a.switch.l1', function(e) {
		e.preventDefault();
		console.log('L1');
		$('.switch.btn').removeClass('-active');
		$(e.target).addClass('-active');
		$('.l2.cities').removeClass('show');
		$('.l1.cities').addClass('show');
	});
	$('body').on('click', 'a.switch.l2', function(e) {
		e.preventDefault();
		console.log('L2');
		$('.switch.btn').removeClass('-active');
		$(e.target).addClass('-active');
		$('.l1.cities').removeClass('show');
		$('.l2.cities').addClass('show');
	});
	$('a.switch.-active').click();
};

Fields.prototype.init = function(){
	//console.log('inicjacja starej wyszukiwarki');
	this.showDropdownAfterDegree();
	
	var step = 0; //dla wyszukiwarki na glownej

	// sprawdzanie kroku 1-4
	if ($('.select-dropdown-element.degree.-active').length)
		step = 1;

	if ($('.select-dropdown-element.city.-active').length)
		step = 2;

	if ($('.select-dropdown-element.degree_type.-active').length)
		step = 3;

	if ($('.select-dropdown-element.form.-active').length)
		step = 4;

	//conslole.log('Step = ' + step);
	if ($('.fields-index-search').length) {
	 	//console.log('robie update ' + step);
	 	this.updateInputs(step);
	}
};

Fields.prototype.showDropdownAfterDegree = function() {
	var self = this;

	self.prefix_url = '';
	self.lang = lang;
	if (self.lang=='en')
		self.prefix_url = "/"+lang;
	self.degree = $(".fields-index-search:not(.v2) .dropdown-input-container[data-step='1'] .select-dropdown-element.-active").length ? $(".fields-index-search:not(.v2) .dropdown-input-container[data-step='1'] .select-dropdown-element.-active").attr('data-degree') : '';
	self.city = $(".fields-index-search:not(.v2) .dropdown-input-container[data-step='2'] .select-dropdown-element.-active").length ? $(".fields-index-search:not(.v2) .dropdown-input-container[data-step='2'] .select-dropdown-element.-active").attr('data-city') : '';
	self.degree_type = $(".fields-index-search:not(.v2) .dropdown-input-container[data-step='3'] .select-dropdown-element.-active").length ? $(".fields-index-search:not(.v2) .dropdown-input-container[data-step='3'] .select-dropdown-element.-active").attr('data-degree_type') : '';
	self.form = $(".fields-index-search:not(.v2) .dropdown-input-container[data-step='4'] .select-dropdown-element.-active").length ? $(".fields-index-search:not(.v2) .dropdown-input-container[data-step='4'] .select-dropdown-element.-active").attr('data-form') : '';
	self.link = self.prefix_url+'/search-fields?city='+self.city+'&degree='+self.degree+'&degree_type='+self.degree_type+'&form='+self.form;
	$('.fields-index-search:not(.v2) .submit-container').find('.submit').attr('href', self.link);

	$(".fields-index-search:not(.v2) .dropdown-input-container[data-step='1'] .select-dropdown-element").on('click keydown', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));

			self.degree = $(e.target).attr('data-degree');

			$(".fields-index-search:not(.v2) .dropdown-input-container[data-step='3']").find('.select-dropdown-element').removeClass('-exists');
			$(".fields-index-search:not(.v2) .dropdown-input-container[data-step='3']").find('.select-dropdown-element[data-degree="'+self.degree+'"]').addClass('-exists');

			self.resetInput([2, 3, 4, 5]);
			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields?city='+self.city+'&degree='+self.degree+'&degree_type='+self.degree_type+'&form='+self.form;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});

	$(".fields-index-search:not(.v2) .dropdown-input-container[data-step='2'] .select-dropdown-element").on('click keydown', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));

			self.city = $(e.target).attr('data-city');

			self.resetInput([3, 4, 5]);
			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields?city='+self.city+'&degree='+self.degree+'&degree_type='+self.degree_type+'&form='+self.form;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});

	$('body').on('click keydown', '.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"] .select-dropdown-element', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));

			self.degree_type = $(e.target).attr('data-degree_type');

			self.resetInput([4, 5]);
			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields?city='+self.city+'&degree='+self.degree+'&degree_type='+self.degree_type+'&form='+self.form;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});

	$(".fields-index-search:not(.v2) .dropdown-input-container[data-step='4'] .select-dropdown-element").on('click keydown', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			var step = parseInt($(e.target).closest('.dropdown-input-container').attr('data-step'));

			self.form = $(e.target).attr('data-form');

			self.resetInput([5]);
			self.updateInputs(step);

			self.link = self.prefix_url+'/search-fields?city='+self.city+'&degree='+self.degree+'&degree_type='+self.degree_type+'&form='+self.form;
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn);
			$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
		}
	});

	$('body').on('click keydown', '.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"] .select-dropdown-element', function(e){
		if (e.type === 'click' || ['Enter'].includes(e.key)) {
			e.preventDefault();

			self.link = $(this).attr('data-link');

			if (self.link != '') {
				$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').text(searchTranslate[self.lang].btn3);
				$(this).closest('.dropdown-input-container').siblings('.submit-container').find('.submit').attr('href', self.link);
			}
		}
	});

};

Fields.prototype.updateInputs = function(clicked_step) {
	var self = this;
	
	var _data = {'city':self.city,'degree':self.degree,'form':self.form,'degree_type':self.degree_type};
	
	// $('.fields-index-search .dropdown-input-container').addClass('-disabled');

	//console.log('updateInputs ' + clicked_step);

	switch (clicked_step) {
		case 0:
		case 1:
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="2"]').addClass('-disabled');
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').addClass('-disabled');			
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').addClass('-disabled');
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').addClass('-disabled');
			break;
		case 2:				
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').addClass('-disabled');			
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').addClass('-disabled');
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').addClass('-disabled');
			break;
		case 3:
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').addClass('-disabled');
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').addClass('-disabled');
			break;
		case 4:
			$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').addClass('-disabled');
			break;
	}

	$('.fields-index-search:not(.v2) .submit').addClass('-disabled').attr('tabindex', '-1');

	if (typeof self.xhr !== 'undefined')
		self.xhr.abort();

	//console.log('inicjuje wyszukiwarke (clicked_step - '+ clicked_step + ' ' + self.prefix_url+'/search-fields');

	if (clicked_step>0)
	self.xhr = $.ajax({
		type        : 'POST',
		url         : self.prefix_url+'/search-fields',
		data        : _data,
		dataType    : 'json',
	}).done(function(data) {
		
		switch (clicked_step) {
			case 1:
				//city
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="2"]').find('.select-dropdown-element').removeClass('-exists');
				$.each(data.cities, function(i, v) {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="2"]').find('.select-dropdown-element[data-city="'+v.id+'"]').addClass('-exists');
				});
				
				//degree_type
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').find('.select-dropdown-element').removeClass('-exists');
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').find('.select-dropdown-background').find('.select-dropdown-element.-added').remove();
				if (self.degree > 2) {
					$.each(data.degree_type, function(i, v) {
						$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').find('.select-dropdown-background').append('<button class="select-dropdown-element -exists -added" data-degree_type="'+v.id+'">'+v.title+'</button>');
					});
				} else {
					$.each(data.degree_type, function(i, v) {
						$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').find('.select-dropdown-element[data-degree_type="'+v.id+'"]').addClass('-exists');
					});
				}		

				//form
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').find('.select-dropdown-element').removeClass('-exists');
				if (self.degree != 3) {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').removeClass('-hidden');
					$.each(data.form, function(i, v) {
						$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').find('.select-dropdown-element[data-form="'+v+'"]').addClass('-exists');
					});
				} else {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').addClass('-hidden');
				}

				if (self.degree == 3) {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').addClass('-hidden');
				} else {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').removeClass('-hidden');
				}

				//podmiana tekstow
				if ($('.submit-container a').length) {
					if (self.degree == 5) {
						$('.fields-index-search:not(.v2) .fields-index-search .title-column').html(searchTranslate[self.lang].head2);
						$('.fields-index-search:not(.v2) .submit-container a').html(searchTranslate[self.lang].btn2);
						$(".fields-index-search:not(.v2) .title-form.select-box__text").attr('data-title', searchTranslate[self.lang].type2).html(searchTranslate[self.lang].type2);
						$(".fields-index-search:not(.v2) .title-type.select-box__text").attr('data-title', searchTranslate[self.lang].type3).html(searchTranslate[self.lang].type3);
					} else {
						$('.fields-index-search:not(.v2) .submit-container a').html(searchTranslate[self.lang].btn);
						$(".fields-index-search:not(.v2) .title-form.select-box__text").attr('data-title', searchTranslate[self.lang].type).html(searchTranslate[self.lang].type);
						$(".fields-index-search:not(.v2) .title-type.select-box__text").attr('data-title', searchTranslate[self.lang].type4).html(searchTranslate[self.lang].type4);
					}
				}

				//chairs
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').find('.select-dropdown-element').remove();
				var chairsHtml = '';
				$.each(data.chairs, function(i, v) {
					chairsHtml += '<button class="select-dropdown-element level -exists" data-link="'+v.url+'">'+v.title+'</button>';
				});
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').find('.select-dropdown-background').append(chairsHtml);
				
				break;
			case 2:				
				//degree_type
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').find('.select-dropdown-element').removeClass('-exists');
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').find('.select-dropdown-background').find('.select-dropdown-element.-added').remove();
				if (self.degree > 2) {
					$.each(data.degree_type, function(i, v) {
						$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').find('.select-dropdown-background').append('<button class="select-dropdown-element -exists -added" data-degree_type="'+v.id+'">'+v.title+'</button>');
					});
				} else {
					$.each(data.degree_type, function(i, v) {
						$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="3"]').find('.select-dropdown-element[data-degree_type="'+v.id+'"]').addClass('-exists');
					});
				}		

				//form
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').find('.select-dropdown-element').removeClass('-exists');
				$.each(data.form, function(i, v) {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').find('.select-dropdown-element[data-form="'+v+'"]').addClass('-exists');
				});

				//chairs
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').find('.select-dropdown-element').remove();
				$.each(data.chairs, function(i, v) {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').find('.select-dropdown-background').append('<button class="select-dropdown-element level -exists" data-link="'+v.url+'">'+v.title+'</button>');
				});
				break;
			case 3:
				//form
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').find('.select-dropdown-element').removeClass('-exists');
				$.each(data.form, function(i, v) {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="4"]').find('.select-dropdown-element[data-form="'+v+'"]').addClass('-exists');
				});

				//chairs
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').find('.select-dropdown-element').remove();
				$.each(data.chairs, function(i, v) {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').find('.select-dropdown-background').append('<button class="select-dropdown-element level -exists" data-link="'+v.url+'">'+v.title+'</button>');
				});
				break;
			case 4:
				//chairs
				$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').find('.select-dropdown-element').remove();
				$.each(data.chairs, function(i, v) {
					$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="5"]').find('.select-dropdown-background').append('<button class="select-dropdown-element level -exists" data-link="'+v.url+'">'+v.title+'</button>');
				});
				break;
		}

		self.resetInput([5]);
		
		$('.fields-index-search:not(.v2) .dropdown-input-container').each(function() {
			if (!$(this).find('.select-dropdown-element.-exists').length) {
				$(this).addClass('-disabled').find('.select-box').attr('tabindex', '-1');
			} else {
				$(this).removeClass('-disabled').find('.select-box').attr('tabindex', '0');
			}
		});
		if (Object.keys(data.chairs).length)
			$('.fields-index-search:not(.v2) .submit').removeClass('-disabled').attr('tabindex', '0');
	});

};

Fields.prototype.resetInput = function(inputs_arr) {
	var self = this;

	$.each(inputs_arr, function(i, v) {
		switch (v) {
			case 1:
				self.degree = '';
				break;
			case 2:
				self.city = '';
				break;
			case 3:
				self.degree_type = '';
				break;
			case 4:
				self.form = '';
				break;
		}

		$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="'+v+'"]').find('.select-box__text').text($('.fields-index-search:not(.v2) .dropdown-input-container[data-step="'+v+'"]').find('.select-box__text').attr('data-title'));
		$('.fields-index-search:not(.v2) .dropdown-input-container[data-step="'+v+'"]').find('.select-dropdown-element.-active').removeClass('-active');
	});
};